"use strict";

exports.__esModule = true;
exports.DATE_FORMATS = exports.DATE_LOCALES = void 0;

var _lodash = require("lodash");

var _blogLanguages = require("@wix/communities-blog-universal/dist/src/constants/blog-languages");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DATE_LOCALES = _objectSpread({}, (0, _lodash.zipObject)(_blogLanguages.blogLanguagesWithRtl, _blogLanguages.blogLanguagesWithRtl), {
  tl: 'tl-ph',
  zh: 'zh-cn',
  no: 'nb'
});

exports.DATE_LOCALES = DATE_LOCALES;
var DEFAULT_DATE_FORMAT = 'MMM D';

var DATE_FORMATS = _objectSpread({}, (0, _lodash.reduce)(_blogLanguages.blogLanguagesWithRtl, function (acc, value) {
  var _objectSpread2;

  return _objectSpread({}, acc, (_objectSpread2 = {}, _objectSpread2[value] = DEFAULT_DATE_FORMAT, _objectSpread2));
}, {}), {
  ko: 'MMM Do',
  ja: 'MMMDo'
});

exports.DATE_FORMATS = DATE_FORMATS;